<template>
	<div>
		<div class="flash-container top-right" v-if="Object.keys(notifications.topRight).length">
			<Notify
				v-for="k in Object.keys(notifications.topRight)"
				:key="k"
				:notification="Object.assign(notifications.topRight[k])"
				@leave="leave"
			></Notify>
		</div>
		<div class="flash-container top-left" v-if="Object.keys(notifications.topLeft).length">
			<Notify
				v-for="k in Object.keys(notifications.topLeft)"
				:key="k"
				:notification="Object.assign(notifications.topLeft[k])"
				@leave="leave"
			></Notify>
		</div>
		<div class="flash-container bottom-right" v-if="Object.keys(notifications.bottomRight).length">
			<Notify
				v-for="k in Object.keys(notifications.bottomRight)"
				:key="k"
				:notification="Object.assign(notifications.bottomRight[k])"
				@leave="leave"
			></Notify>
		</div>
		<div class="flash-container bottom-left" v-if="Object.keys(notifications.bottomLeft).length">
			<Notify
				v-for="k in Object.keys(notifications.bottomLeft)"
				:key="k"
				:notification="Object.assign(notifications.bottomLeft[k])"
				@leave="leave"
			></Notify>
		</div>
	</div>
</template>
<script>
import './Notifications.css'
import Notify from './Notify.vue'
export default {
	name: 'notificatios',
	props: ['area'],
	components: {
		Notify,
	},
	data() {
		return {
			timeLeft: 300,
			notifications: {
				topRight: {},
				topLeft: {},
				bottomRight: {},
				bottomLeft: {},
			},
			availableArea: ['topRight', 'topLeft', 'bottomRight', 'bottomLeft'],
		}
	},
	methods: {
		getTimeLeft(notification) {
			return notification.hasOwnProperty('timeLeft')
				? parseInt(notification.timeLeft)
				: this[notification.area + 'TimeLeft'] || this.timeLeft
		},

		notify(notification) {
			if (!this.notifications[notification.area].hasOwnProperty(notification.index)) {
				this[notification.area + 'TimeLeft'] += this.getTimeLeft(notification)
				setTimeout(() => {
					this.notifications[notification.area] = {
						...this.notifications[notification.area],
						[notification.index]: notification,
					}
				}, this[notification.area + 'TimeLeft'])
			}
		},
		leave(notification) {
			if (this.$root.notifications[notification.index]) {
				if (is_func(this.$root.notifications[notification.index].callback)) {
					this.$root.notifications[notification.index].callback()
				}

				delete this.$root.notifications[notification.index]
				this.$root.notifications = {...this.$root.notifications}
				delete this.notifications[notification.area][notification.index]
				this.notifications[notification.area] = {...this.notifications[notification.area]}
				this[notification.area + 'TimeLeft'] -= this.getTimeLeft(notification)
			}
		},
	},
	watch: {
		'$root.notifications': function(notifications) {
			try {
				for (var i in notifications) {
					notifications[i].index = i
					if (this.availableArea.indexOf(notifications[i].area) < 0) {
						notifications[i].area = this.availableArea.indexOf(this.area) < 0 ? 'topRight' : this.area
					}
					this.notify(notifications[i])
				}
			} catch (e) {
				console.warn('Browser not support es6 syntax')
			}
		},
	},
}
</script>
